import React, { Component } from 'react';
import { orderBy } from 'lodash';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import ModuleExport from '../../../ModuleExport';
import BaseDataTable from '../../../BaseDataTable';
import TableHead from '../TableElement/TableHead';
import TableSummary from '../TableElement/TableSummary';
import StationTableRow from '../TableElement/StationTableRow';
import {
  MIN_LENGTH_PLACEMENT_STATION,
  STATION_CHART_ID,
  MAX_NUMBER_TABLE_ROWS_TO_TRUNCATE,
  SORT_BY_VISIT_PER_AD,
  SORT_BY_NEW_AD_USERS_PER_ADS
} from '../../../../helpers/constant';
import {
  PLACEMENT_STATION_TABLE_FILE_NAME,
  stationShape,
  NEW_AD_USERS,
} from '../constants';

import styles from './styles.scss';
import { calculateTableRows } from '../../Report/helper';

export class PlacementStationTable extends Component {
  static propTypes = {
    tableHeaders: arrayOf(shape({
      title: string,
      key: string
    })),
    data: arrayOf(stationShape),
    onCellClick: func,
    fileName: string,
    summaryTitle: string,
    inpdf: bool,
    page: number,
    rowsPerPage: number,
    isGrandTotalDisplay: bool,
    beginStation: number,
    campaignAvgAdCost: number,
    isCustomReport: bool,
    displayStationChart: bool,
    itemIndex: number,
    tableSortSelector: shape({
        sortKey: string,
        sortType: string
    }),
    isNewAdUsersEnabled: bool,
    selectedDataType: string,
    rowsFirstPage: number,
  };

  static defaultProps = {
    tableHeaders: [
      { title: 'Station', key: 'title' },
      { title: 'Ad Visits', key: 'adVisit' },
      { title: 'Ads', key: 'ads' },
      { title: 'Ad Visits/Ads', key: 'visitOfAds' },
      { title: 'Avg. Ad Cost', key: 'avgAdCost' }
    ],
    fileName: PLACEMENT_STATION_TABLE_FILE_NAME,
    summaryTitle: 'Grand Total',
    data: []
  };

  handleCellClick = ({ data }) => {
    const { onCellClick } = this.props;

    onCellClick && onCellClick(data, STATION_CHART_ID);
  };

  prepData() {
    const {
      data,
      inpdf,
      page,
      rowsPerPage,
      summaryTitle,
      beginStation,
      tableSortSelector,
      displayStationChart,
      isCustomReport,
      isNewAdUsersEnabled,
      selectedDataType,
      rowsFirstPage
    } = this.props;
    const dataSet = data.reduce((accum, currEntry) => {
      const {
        stationName,
        stationId,
        isStation,
        adVisit,
        aired,
        adUser,
        visitOfads,
        avgAdCost,
        sumAvgAdCost,
        numPricedAds,
        newAdUsers,
      } = currEntry;
      const newAdUsersOfAds = aired ? parseFloat((newAdUsers/aired).toFixed(2)) : 0;
      if (stationName && stationId) {
        accum.tableData.push({
          title: stationName,
          stationId,
          isStation,
          avgAdCost,
          ads: aired || 0,
          adUser: adUser || 0,
          adVisit: adVisit || 0,
          newAdUsers: newAdUsers || 0,
          newAdUsersOfAds,
          visitOfAds: visitOfads || 0
        });
        accum.summaryData.ads += aired || 0;
        accum.summaryData.adVisit += adVisit || 0;
        accum.summaryData.adUser += adUser || 0;
        accum.summaryData.sumAvgAdCost += sumAvgAdCost || 0;
        accum.summaryData.pricedAds += numPricedAds || 0;
        accum.summaryData.newAdUsers += newAdUsers || 0;
        accum.summaryData.newAdUsersOfAds += newAdUsersOfAds || 0;
      }
      return accum;
    }, {
      tableData: [],
      summaryData: {
        title: summaryTitle,
        ads: 0,
        adVisit: 0,
        adUser: 0,
        sumAvgAdCost: 0,
        pricedAds: 0,
        newAdUsers: 0, 
        newAdUsersOfAds: 0,
      }
    });

    dataSet.summaryData.visitOfAds = !dataSet.summaryData.ads
      ? 0 : parseFloat((dataSet.summaryData.adVisit / dataSet.summaryData.ads).toFixed(2)) || 0;

    dataSet.summaryData.avgAdCost = !dataSet.summaryData.pricedAds
      ? 0 : parseFloat(dataSet.summaryData.sumAvgAdCost / dataSet.summaryData.pricedAds) || 0;

    dataSet.summaryData.newAdUsersOfAds = !dataSet.summaryData.ads
      ? 0 : parseFloat((dataSet.summaryData.newAdUsers / dataSet.summaryData.ads).toFixed(2));

    //TODO: Update this when new report is ready
    if (inpdf) {
      const showNewAdUsers = isNewAdUsersEnabled && selectedDataType === NEW_AD_USERS;
      const defaultSortStatus = showNewAdUsers ? SORT_BY_NEW_AD_USERS_PER_ADS : SORT_BY_VISIT_PER_AD;
      const initialSortStatus = tableSortSelector || defaultSortStatus;
      const { sortKey, sortType } = initialSortStatus || {};
      dataSet.tableData = orderBy(dataSet.tableData, [sortKey], sortType);
      const rowsOnFirstPage = rowsFirstPage || MIN_LENGTH_PLACEMENT_STATION;
      const start = rowsFirstPage ? 0 :  beginStation;
      const minRows = rowsOnFirstPage;
      const { tableRowsFirstPage, tableRowsOtherPage } = calculateTableRows({ displayChart: displayStationChart, isCustomReport, minRows: minRows, truncatedRows: 0 });
      if (page === start) {
        dataSet.tableData = dataSet.tableData.slice(0, rowsPerPage);
      } else {
        const startIndex = (tableRowsFirstPage + 1) + (page - start - 1) * (tableRowsOtherPage + 1);
        dataSet.tableData = dataSet.tableData.slice(startIndex, startIndex + rowsPerPage);
      }
    }

    return dataSet;
  }

  prepCsvData(data, headers, isAvgCostDisabled, isShowNewAdUsers) {
    const csvHeaders = headers && headers.map(header => header.title);

    //TODO: put adUser back when VTN-34808 is ready
    return data && data.reduce((accum, currentEntry) => {
      const {
        title,
        avgAdCost,
        ads,
        //adUser,
        adVisit,
        visitOfAds,
        newAdUsers,
        newAdUsersOfAds,
      } = currentEntry;
      const row = [
        title, 
        isShowNewAdUsers ? newAdUsers : adVisit, 
        ads, 
        isShowNewAdUsers ? newAdUsersOfAds : visitOfAds,
      ];
      const formattedAvgAdCost = typeof avgAdCost === 'number' ? avgAdCost.toFixed(2) : 'N/A';
      !isAvgCostDisabled && row.push(formattedAvgAdCost);
      accum.push(row);
      return accum;
    }, [csvHeaders]);
  }

  tableExportContainer = React.createRef();

  render() {
    const {
      tableHeaders,
      inpdf,
      fileName,
      rowsPerPage,
      isGrandTotalDisplay,
      page,
      campaignAvgAdCost,
      isCustomReport,
      itemIndex,
      tableSortSelector,
      isNewAdUsersEnabled,
      selectedDataType,
    } = this.props;

    const dataSet = this.prepData();
    const isAvgCostDisabled = campaignAvgAdCost === null;
    const isShowNewAdUsers = isNewAdUsersEnabled && selectedDataType === NEW_AD_USERS;
    // TODO: Replace headers with adUser when implemented and selected from dropdown.
    let headers = [...tableHeaders];
    if (isShowNewAdUsers) {
      headers[1] = { title: 'New Ad Users', key: 'newAdUsers' }
      headers[3] = { title: 'New Ad Users/Ads', key: 'newAdUsersOfAds' }
    };
    headers = isAvgCostDisabled ? headers.slice(0, headers.length - 1): headers;
    const csvData = this.prepCsvData(dataSet.tableData, headers, isAvgCostDisabled, isShowNewAdUsers);
    const defaultSort = isShowNewAdUsers ? SORT_BY_NEW_AD_USERS_PER_ADS : SORT_BY_VISIT_PER_AD;
    const initialSortStatus = tableSortSelector ? tableSortSelector : defaultSort;

    return (
      <div className={styles.tableContainer} ref={this.tableExportContainer}>
        <ModuleExport
          exportImg={this.tableExportContainer}
          data={csvData}
          fileName={fileName}
          exportContainerStyle={{ padding: '0 20px 0 0' }}
        />
        <BaseDataTable
          data={dataSet.tableData}
          tableHead={<TableHead headers={headers}/>}
          tableRow={
            <StationTableRow
              isAvgCostDisabled={isAvgCostDisabled}
              isCustomReport={isCustomReport}
              isShowNewAdUsers={isShowNewAdUsers}
            />
          }
          tableSummary={
            <TableSummary
              isAvgCostDisabled={isAvgCostDisabled}
              summaryData={dataSet.summaryData}
              isShowNewAdUsers={isShowNewAdUsers}
            />
          }
          onBodyCellClick={this.handleCellClick}
          initialSortStatus={initialSortStatus}
          pagination
          page={page}
          inpdf={inpdf}
          rowsPerPage={rowsPerPage}
          isGrandTotalDisplay={isGrandTotalDisplay}
          tableId={STATION_CHART_ID}
          tableIndex={itemIndex}
          isCustomReport={isCustomReport}
        />
      </div>
    );
  }
}

import { connect } from 'react-redux';
import { getTableSortSelector } from '../../Report/helper';

function mapStateToProps(state, props) {
  return {
    tableSortSelector: getTableSortSelector(state, props, STATION_CHART_ID),
  }
}

export default connect(mapStateToProps)(PlacementStationTable);
